export enum AssetType {
    Clo = 'CLO'
}

export const AssetTypeList = [AssetType.Clo];
